module.exports = __webpack_public_path__ + "img/PR1-B.a7485085.png";